import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    title: {
      flexGrow: 1,
      textAlign: 'center',
    }
  }));

export default useStyles;